// client/src/components/COMMERCANT/GestionTabs.js
// Barre d'onglets commune aux pages Gestion (Employés / Fidélité / Clients / Promotions).
// Fidélité et Clients sont deux vues de /merchantgestion (choisies via location.state.view).
import React from 'react';
import { useNavigate } from 'react-router-dom';

const TABS = [
  { key: 'staff', label: 'Employés', path: '/merchantgestionstaff' },
  { key: 'activity', label: 'Fidélité', path: '/merchantgestion', view: 'activity' },
  { key: 'clients', label: 'Clients', path: '/merchantgestion', view: 'clients' },
  { key: 'promo', label: 'Promotions', path: '/merchantgestionpromo' },
];

/**
 * @param {string} active  clé de l'onglet actif
 * @param {(view: string) => void} [onSelectView]  fourni par MerchantGestion pour basculer
 *        Fidélité/Clients sans changer de page
 */
export default function GestionTabs({ active, onSelectView }) {
  const navigate = useNavigate();

  const select = (tab) => {
    if (tab.key === active) return;
    if (tab.view && onSelectView) {
      onSelectView(tab.view);
      return;
    }
    navigate(tab.path, tab.view ? { state: { view: tab.view } } : undefined);
  };

  return (
    <div className="tabs-pill" role="tablist">
      {TABS.map((tab) => {
        const isActive = tab.key === active;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => select(tab)}
            className={`tab${isActive ? ' tab-active' : ''}`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
